export const RQ_PRESCRIPTION_ADD_API = {
  url: 'Prescription',
  method: 'POST',
  auth: true,
};

export const RQ_PRESCRIPTION_UPDATE_API = {
  url: 'Prescription/<%= id %>',
  method: 'PATCH',
  auth: true,
};

export const RQ_PRESCRIPTION_LOOKUP_ID_API = {
  url: 'Prescription/<%= id %>',
  method: 'GET',
  auth: true,
};

export const RQ_PRESCRIPTION_LOOKUP_PATIENT_API = {
  url: 'Prescription/patient/<%= patientId %>',
  method: 'GET',
  auth: true,
};

export const RQ_PRESCRIPTION_LOOKUP_API = {
  url: 'Prescription',
  method: 'GET',
  auth: true,
};

export const RQ_PRESCRIPTION_DELETE_API = {
  url: 'Prescription/<%= id %>',
  method: 'DELETE',
  auth: true,
};
